import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabaseClient } from '../../config/supabase';
import { loggingService } from '../../services/loggingService';
import { monitoringService } from '../../services/monitoringService';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Pobierz i zapisz hash URL, ponieważ supabase go analizuje i usuwa
        const hashParams = window.location.hash;
        console.log('Auth callback hash params:', hashParams);
        
        // Sprawdź, czy używamy standardowego flow OTP czy OAuth
        const isOAuthFlow = hashParams.includes('access_token') || hashParams.includes('error');
        
        if (isOAuthFlow) {
          // Pozwól Supabase obsłużyć uwierzytelnianie OAuth
          const { data, error } = await supabaseClient.auth.getSession();
          if (error) {
            throw error;
          }
          
          if (data?.session) {
            console.log('Auth session established:', data.session);
            monitoringService.trackUserBehavior('auth_callback_success');
            
            // Sprawdź czy mamy zapisane tymczasowe odpowiedzi na quiz
            const tempQuizAnswers = sessionStorage.getItem('tempQuizAnswers');
            
            // Redirect do dashboardu lub na stronę główną
            if (tempQuizAnswers) {
              navigate('/dashboard');
            } else {
              navigate('/dashboard');
            }
          } else {
            console.error('No session after auth callback');
            setError('Nie udało się zalogować. Spróbuj ponownie.');
            setTimeout(() => navigate('/'), 3000);
          }
        } else {
          // Standardowe flow
          const { data, error } = await supabaseClient.auth.getSession();
          if (error) {
            throw error;
          }
          
          if (data?.session) {
            navigate('/dashboard');
          } else {
            setError('Nie udało się zalogować. Spróbuj ponownie.');
            setTimeout(() => navigate('/'), 3000);
          }
        }
      } catch (err) {
        console.error('Error in auth callback:', err);
        loggingService.error('Auth callback error', err);
        setError('Wystąpił błąd podczas próby logowania. Spróbuj ponownie.');
        setTimeout(() => navigate('/'), 3000);
      }
    };

    handleAuthCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-8 text-center">
          <div className="text-red-500 text-lg mb-4">
            {error}
          </div>
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg"
          >
            Powrót do strony głównej
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-purple-600 mx-auto mb-4" />
        <h1 className="text-xl font-medium text-gray-900 mb-2">
          Trwa logowanie...
        </h1>
        <p className="text-gray-600">
          Za chwilę zostaniesz przekierowany do panelu.
        </p>
      </div>
    </div>
  );
}
